import * as yup from "yup";
import { baseStringDto } from "./common";

const formStepDto = yup.object().shape({
  id: yup.string().required(),
  title: baseStringDto("Step Title", 3),
  fields: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required(),
        label: baseStringDto("Field Title", 3),
        crmKey: yup.string().required(),
      })
    )
    .required("At least one field is required.")
    .min(1, "At least one field is required."),
});

export const formJsonDto = yup.object().shape({
  title: baseStringDto("Form Title", 3),
  userType: yup.string().required("User type is required."),
  steps: yup
    .array()
    .of(formStepDto)
    .required("At least one step is required.")
    .min(1, "At least one step is required."),
});
